export default function addDaysToDate(days) {
  const date = new Date();
  date.setDate(date.getDate() + days);

  return date;
}
